export default __webpack_public_path__ + "static/media/path.720c8ac7.svg";